/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { TextField, MenuItem, Chip, Paper } from '@mui/material';
import * as React from 'react';
import Downshift from 'downshift';
function renderInput(inputProps: any) {
  const { InputProps, classes, ref, ...other } = inputProps;

  return (
    <TextField
      name="textFieldDownshift"
		  className={classes.formLabel}
		  InputProps={{
			  inputRef: ref,
			  classes: {
				  root: classes.inputRoot,
				  input: classes.inputInput
			  },
			  ...InputProps,
		  }}
		  {...other}
	  />
	);
}

function renderSuggestion(suggestionProps: any) {
  const { classes, suggestion, index, itemProps, highlightedIndex, selectedItem,key,value } = suggestionProps;
  const isHighlighted = highlightedIndex === index;
  const isSelected = (selectedItem || '').indexOf(suggestion[value]) > -1;

  return (    
    <MenuItem
      {...itemProps}
      className={classes.menuItem}
      key={suggestion[key]}
      value={suggestion[key]}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 1000 : 100,
      }}
      id={suggestion[value]}
    >
      {suggestion[value]}
    </MenuItem>
  );
}


interface Props {
  updateSelection: Function;
  classes?: any;
  values: any;
  initialValue: any;
  id: any;
  value: any;
  label: any
}
export default function DownshiftMultiple(props: Props) {
  const { classes } = props;
  const [inputValue, setInputValue] = React.useState('');
  const [selectedItem, setSelectedItem] = React.useState([]);

  const [isopen, setIsopen] = React.useState(false);

  function handleKeyDown(event: any) {
    if (selectedItem.length && !inputValue.length && event.key === 'Backspace') {
      setSelectedItem(selectedItem.slice(0, selectedItem.length - 1));
      props.updateSelection(selectedItem.slice(0, selectedItem.length - 1));
    }
  }
  React.useEffect(() => {
    setSelectedItem(props.initialValue);
    props.updateSelection(props.initialValue);
  }, [props.initialValue]);
  function handleInputChange(event: any) {
    setInputValue(event.target.value);
  }

  function handleChange(item: any) {
    let newSelectedItem = [...selectedItem];
    if (newSelectedItem.indexOf(item as never) === -1) {
      newSelectedItem = [...newSelectedItem, item] as never[];
    }
    setInputValue('');
    setSelectedItem(newSelectedItem);
    props.updateSelection(newSelectedItem);
    //setIsopen(false)
  }
  function handleFocus() {
    setIsopen(true);
  }
  function handleBlur() {
    setIsopen(false);
  }
  const handleDelete = (item: any) => () => {
    const newSelectedItem = [...selectedItem];
    newSelectedItem.splice(newSelectedItem.indexOf(item as never), 1);
    setSelectedItem(newSelectedItem);
    props.updateSelection(newSelectedItem);
  };

  return (
    <Downshift
      id="downshift-multiple"
      inputValue={inputValue}
      onChange={handleChange}
      selectedItem={selectedItem}
    >
      {({
        getInputProps,
        getItemProps,
        getLabelProps,
        isOpen,
        inputValue: inputValue2,
        selectedItem: selectedItem2,
        highlightedIndex,
      }) => {
        const { onBlur, onChange, ...inputProps } = getInputProps({
          onKeyDown: handleKeyDown,
          placeholder: '',
        });
        return (
          <div className={classes.container}>
            {renderInput({
              fullWidth: true,
              classes,
              label: props.label,
              InputLabelProps: getLabelProps(),
              InputProps: {
                startAdornment: selectedItem.map((item: any) => (
                  <Chip
                    key={item}
                    tabIndex={-1}
                    label={item}
                    className={classes.chip}
                    onDelete={handleDelete(item)}
                  />
                )),
                onBlur: (event: any) => {
                  handleBlur();
                },
                onChange: (event: any) => {
                  handleInputChange(event);
                  onChange !== undefined && onChange(event);
                },
                onFocus: (event: any) => {
                  handleFocus();
                },
              },
              inputProps,
            })}

            {isopen ? (
              <Paper className={classes.dropdown} square>
                {props.values.map((suggestion: any, index: number) =>
                  renderSuggestion({
                    classes,
                    suggestion,
                    index,
                    itemProps: getItemProps({ item: suggestion[props.value] }),
                    highlightedIndex,
                    selectedItem: selectedItem2,
                    key: props.id,
                    value: props.value
                  }),
                )}
              </Paper>
            ) : null}
          </div>
        );
      }}
    </Downshift>
  );
}
